import { eventBus } from './eventBus.js'
import { endpoints } from '../../endpoints.js'
import { SerializerFactory } from '../serializers/serializerFactory.js'
import { cacheManager } from '../storage/cacheManager.js'
import { DelayedRequestQueue } from './delayedRequestQueue.js'

export class RequestManager {
  constructor() {
    this.delayedQueue = new DelayedRequestQueue()
    this.setup()
  }

  setup() {
    // Configure le délai après le setup
    this.delayedQueue.setup(150) // tu peux changer ici

    const actions = [
      'GET_DATA',
      'POST_DATA',
      'PUT_DATA',
      'PATCH_DATA',
      'DELETE_DATA',
    ]

    actions.forEach(action => {
      eventBus.on(action, ({ entityType, payload, requestId }) => {
        // Chaque requête passe par la queue différée
        this.handleRequest(action, { entityType, payload, requestId })
        // this.delayedQueue.schedule(() =>
        // )
      })
    })
  }

  async handleRequest(action, { entityType, payload, requestId }) {
    try {
      const method = this.getMethod(action)
      const url = this.getUrl(entityType, method, payload)

      if (!url) {
        return eventBus.emit(`RESPONSE:${requestId}`, {
          statusCode: 200,
          message: `URL is missing or null for ${action} on ${entityType} - Request Skipped`,
          data: { success: false, skipped: true },
        })
      }

      if (method === 'GET') {
        const cached = await cacheManager.get(method, url)
        if (cached) {
          return eventBus.emit(`RESPONSE:${requestId}`, {
            statusCode: 200,
            message: 'Loaded from cache',
            data: cached,
          })
        }
      }

      const options = await this.buildOptions(method, payload, entityType)
      const response = await fetch(url, options)
      const data = await response.json()

      const serializer = SerializerFactory.get(entityType)
      const finalData = serializer.deserialize(data, payload, method) || {}
      finalData.raw = data

      eventBus.emit(`RESPONSE:${requestId}`, {
        statusCode: finalData.statusCode || response.status,
        message: finalData.message || data.message || 'Request processed',
        data: finalData,
      })
    } catch (error) {
      eventBus.emit(`RESPONSE:${requestId}`, {
        statusCode: 500,
        message: 'Network or parsing error',
        error: error.message,
      })
    }
  }

  getMethod(action) {
    const map = {
      GET_DATA: 'GET',
      POST_DATA: 'POST',
      PUT_DATA: 'PUT',
      PATCH_DATA: 'PATCH',
      DELETE_DATA: 'DELETE',
    }
    return map[action]
  }

  getUrl(entityType, method, payload) {
    const endpoint = endpoints[entityType]
    if (!endpoint || !endpoint[method]) {
      throw new Error(`No URL available for ${method} method on ${entityType}`)
    }
    return endpoint[method](payload)
  }

  async buildOptions(method, payload, entityType) {
    const options = { method }

    if (['POST', 'PUT', 'PATCH'].includes(method) && payload) {
      const serializer = SerializerFactory.get(entityType)
      const serializedPayload = await serializer.serialize(payload)
      options.headers = { 'Content-Type': 'application/json' }
      options.body = JSON.stringify(serializedPayload)
    }

    return options
  }
}
